import { render } from "./SubmitReform.vue?vue&type=template&id=bb55e112&scoped=true"
import script from "./SubmitReform.vue?vue&type=script&lang=js"
export * from "./SubmitReform.vue?vue&type=script&lang=js"

import "./SubmitReform.vue?vue&type=style&index=0&id=bb55e112&scoped=true&lang=css"

import exportComponent from "D:\\pro\\edu-hsd\\cxcj\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb55e112"]])

export default __exports__